import { render, staticRenderFns } from "./DebtCollection.vue?vue&type=template&id=785cc21d"
import script from "./DebtCollection.vue?vue&type=script&lang=js"
export * from "./DebtCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports